import React from "react";

import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import ProfilingSellable from "./ProfilingSellable";
import * as S from "./ProfilingSellable.styles";

const Sellable = () => {
  const isUsageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);

  return isUsageBilling ? (
    <S.BannerWrapper>
      <ProfilingSellable />
    </S.BannerWrapper>
  ) : null;
};

export default Sellable;
